export interface AnimeResource {
  id: string;
  title: string;
  category: string;
  tags: string[];
  cover: string;
  year: number;
  episodes: string;
  status: string;
  rating: number;
  updateTime: string;
  summary: string;
  description: string;
  highlights: string[];
  sourceNote: string;
}

export interface Category {
  id: string;
  name: string;
  icon: string;
  count: number;
  desc: string;
}

export const categories: Category[] = [
  { id: "hot-blood", name: "热血冒险", icon: "ri-fire-line", count: 128, desc: "打斗燃向、少年热血，追番补番的高人气门类" },
  { id: "fantasy", name: "奇幻魔法", icon: "ri-magic-line", count: 96, desc: "异世界与魔法世界，想象力拉满的长篇经典" },
  { id: "slice", name: "日常治愈", icon: "ri-sun-line", count: 143, desc: "轻快治愈的日常番，下饭与放松首选" },
  { id: "sci-fi", name: "科幻机战", icon: "ri-rocket-2-line", count: 74, desc: "机甲、未来与宏大世界观设定爱好者聚集地" },
  { id: "romance", name: "恋爱校园", icon: "ri-heart-3-line", count: 110, desc: "校园恋爱与青春悸动，甜度与泪点并存" },
  { id: "mystery", name: "悬疑推理", icon: "ri-spy-line", count: 58, desc: "烧脑悬疑与高能反转，一集入坑停不下来" },
];

export const animeResources: AnimeResource[] = [
  {
    id: "attack-on-titan",
    title: "进击的巨人",
    category: "热血冒险",
    tags: ["热血", "动作", "神作"],
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20key%20visual%20of%20a%20determined%20young%20soldier%20in%20a%20brown%20cloak%20and%20gears%20leaping%20toward%20a%20giant%20monster%20on%20the%20horizon%2C%20dramatic%20golden%20hour%20lighting%2C%20dusty%20battlefield%2C%20warm%20orange%20and%20amber%20tones%2C%20high%20detail%20anime%20art%2C%20epic%20cinematic%20composition&width=480&height=640&seq=res-aot&orientation=portrait",
    year: 2013,
    episodes: "全季 87 话",
    status: "已完结",
    rating: 9.4,
    updateTime: "2026-08-16",
    summary: "人类在巨墙中苟活，少年艾伦为夺回自由而踏上复仇之路。被誉为近十年最具影响力的热血神作。",
    description: "城墙之内，人类世代蜷缩在恐惧之中。当超大型巨人踏破城墙的那一天，少年艾伦的世界彻底崩塌。他立誓将巨人一个不留地驱逐出去，加入了调查兵团，与青梅竹马的伙伴们一同直面残酷的真相。全季资源已整理完成，支持高清画质在线观看与下载，追番不迷路。",
    highlights: ["多线叙事与反转神作", "全部剧集高清整理", "剧场版特别篇一并收录"],
    sourceNote: "已整理全季 87 话，含 TV 版与剧场版特别篇，更新至最终季完结篇。",
  },
  {
    id: "jujutsu-kaisen",
    title: "咒术回战",
    category: "热血冒险",
    tags: ["战斗", "黑暗", "超能力"],
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20of%20a%20confident%20teenage%20sorcerer%20with%20spiky%20pink%20hair%20wearing%20a%20dark%20school%20uniform%2C%20surrounded%20by%20cursed%20blue%20flames%20and%20shadow%20monsters%2C%20dramatic%20backlighting%2C%20vivid%20and%20dark%20contrast%2C%20high%20quality%20anime%20key%20visual%20art&width=480&height=640&seq=res-jjk&orientation=portrait",
    year: 2020,
    episodes: "全季 47 话",
    status: "连载中",
    rating: 9.0,
    updateTime: "2026-08-15",
    summary: "吞下特级咒物的虎杖悠仁，为拯救世界加入咒术高专，与诅咒展开生死对决。打斗爽感拉满的年度霸权番。",
    description: "普通人虎杖悠仁为救人吞下特级咒物『宿傩的手指』，从此与诅咒结下不解之缘。在最强咒术师五条悟的引导下，他进入东京都立咒术高专，踏上与诅咒抗争的征途。资源站已同步全部已更新剧集，连载中实时跟进，绝不让你断更。",
    highlights: ["顶级作画与打斗分镜", "连载剧集实时同步", "特典与短篇一并整理"],
    sourceNote: "已整理至最新连载话数，含第一季、怀玉·玉折篇与涩谷事变篇。",
  },
  {
    id: "demon-slayer",
    title: "鬼灭之刃",
    category: "热血冒险",
    tags: ["刀剑", "热血", "催泪"],
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20of%20a%20young%20swordsman%20in%20a%20checkered%20black%20and%20green%20kimono%20holding%20a%20katana%20with%20water%20and%20flame%20effects%2C%20moonlit%20night%20forest%2C%20blue%20and%20warm%20crimson%20highlights%2C%20high%20detail%20anime%20key%20visual%20art&width=480&height=640&seq=res-ds&orientation=portrait",
    year: 2019,
    episodes: "全季 55 话",
    status: "连载中",
    rating: 9.2,
    updateTime: "2026-08-14",
    summary: "炭治郎为让变成鬼的妹妹重新变回人类，挥舞日轮刀踏上斩鬼之旅。现象级热血催泪大作。",
    description: "卖炭少年灶门炭治郎的家人被鬼杀害，唯一幸存的妹妹祢豆子也变成了鬼。为了寻找让妹妹复原的方法，他加入了鬼杀队，以『水之呼吸』与『日之呼吸』迎战强大的恶鬼。全季资源合集完整收录，经典名场面与剧场版同步整理。",
    highlights: ["现象级爆款IP", "全季与剧场版完整收录", "高质量画质修复版"],
    sourceNote: "已整理全季 55 话及剧场版无限列车篇，更新至刀匠村篇与柱训练篇。",
  },
  {
    id: "one-piece",
    title: "海贼王",
    category: "热血冒险",
    tags: ["冒险", "友情", "长篇"],
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20of%20a%20happy%20young%20pirate%20captain%20wearing%20a%20straw%20hat%20smiling%20with%20a%20crew%20of%20friends%20on%20the%20deck%20of%20a%20wooden%20pirate%20ship%2C%20bright%20blue%20ocean%20and%20sunny%20sky%2C%20warm%20and%20joyful%20tone%2C%20vivid%20anime%20art&width=480&height=640&seq=res-op&orientation=portrait",
    year: 1999,
    episodes: "已更新 1100+ 话",
    status: "连载中",
    rating: 9.3,
    updateTime: "2026-08-13",
    summary: "蒙奇·D·路飞立志成为海贼王，与伙伴们向着伟大航路终点前进。跨越二十年的史诗级冒险。",
    description: "『我是要成为海贼王的男人！』路飞吃下橡胶果实，召集了一群志同道合的伙伴，向着传说中的 ONE PIECE 出发。从东海到伟大航路，再到新世界，每一段旅程都充满热血与感动。资源合集已按篇章整理，追更与补番两相宜。",
    highlights: ["跨越二十年的史诗长篇", "按篇章系统整理", "剧场版与特别篇齐全"],
    sourceNote: "已整理至最新连载话数，含东海篇至蛋头岛篇，按篇章分类方便补番。",
  },
  {
    id: "naruto",
    title: "火影忍者",
    category: "热血冒险",
    tags: ["忍术", "成长", "长篇"],
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20of%20a%20young%20ninja%20with%20spiky%20blond%20hair%20wearing%20an%20orange%20jumpsuit%20performing%20a%20hand%20seal%20with%20chakra%20energy%2C%20woodland%20training%20ground%2C%20warm%20sunset%20light%2C%20dynamic%20pose%2C%20vivid%20anime%20art&width=480&height=640&seq=res-nar&orientation=portrait",
    year: 2002,
    episodes: "全季 720 话",
    status: "已完结",
    rating: 9.1,
    updateTime: "2026-08-12",
    summary: "体内封印九尾妖狐的少年鸣人，立志成为火影并获得所有人的认可。无数人的青春热血记忆。",
    description: "漩涡鸣人从小被村里人排斥，体内却封印着九尾妖狐。他以成为火影为目标不断成长，在修行与战斗中收获了羁绊与友情。火影忍者与疾风传全集 720 话资源已完整整理，含剧场版与特别篇，经典之作一站补齐。",
    highlights: ["720 话全集完整收录", "含疾风传与剧场版", "无数人的青春记忆"],
    sourceNote: "火影忍者本篇 + 疾风传 720 话全集已整理，附带 11 部剧场版资源。",
  },
  {
    id: "spy-family",
    title: "间谍过家家",
    category: "日常治愈",
    tags: ["搞笑", "温馨", "家庭"],
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20of%20a%20quirky%20little%20girl%20with%20pink%20hair%20and%20two%20small%20horns%2C%20smiling%20with%20a%20green%20plant%20in%20a%20warm%20cozy%20family%20living%20room%2C%20soft%20natural%20light%2C%20cute%20and%20heartwarming%20tone%2C%20vivid%20anime%20art&width=480&height=640&seq=res-sf&orientation=portrait",
    year: 2022,
    episodes: "全季 37 话",
    status: "连载中",
    rating: 9.0,
    updateTime: "2026-08-11",
    summary: "间谍、杀手、超能力少女组成的临时家庭，在伪装与日常之间笑料百出。解压治愈的国民搞笑番。",
    description: "为了执行任务，间谍黄昏组建了一个『临时家庭』——妻子是职业杀手，女儿是读心的超能力者。三人各怀秘密，却在一地鸡毛的日常中渐渐成为真正的一家人。轻松的搞笑日常与细腻的温情交织，是无数观众的下饭首选。",
    highlights: ["国民级搞笑日常", "轻松解压观看体验", "最新季实时同步"],
    sourceNote: "已整理第一季与第二季共 37 话，剧场版也一并收录。",
  },
  {
    id: "frieren",
    title: "葬送的芙莉莲",
    category: "奇幻魔法",
    tags: ["奇幻", "治愈", "神作"],
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20of%20a%20calm%20long%20silver%20haired%20elven%20mage%20in%20a%20white%20robe%20with%20a%20staff%2C%20standing%20in%20a%20soft%20magical%20meadow%20under%20warm%20twilight%20sky%2C%20gentle%20and%20ethereal%20light%2C%20emotional%20and%20tender%20tone%2C%20high%20quality%20anime%20art&width=480&height=640&seq=res-fr&orientation=portrait",
    year: 2023,
    episodes: "全季 28 话",
    status: "连载中",
    rating: 9.4,
    updateTime: "2026-08-10",
    summary: "勇者一行击败魔王后，长生不老的精灵芙莉莲踏上重新理解『人类』的旅程。近年的口碑天花板。",
    description: "打败魔王之后，芙莉莲与同伴们的冒险告一段落。然而拥有漫长生命的精灵，开始重新审视与人类同伴相处的每一段时光。温柔、静谧又饱含深情的叙事，让这部作品成为无数人心中的年度神作。全季资源与后续篇目持续更新中。",
    highlights: ["近年口碑天花板", "治愈与深思并存的叙事", "高清画质完整整理"],
    sourceNote: "已整理第一季 28 话，第二季制作中，更新动态会第一时间同步。",
  },
  {
    id: "haikyuu",
    title: "排球少年",
    category: "运动竞技",
    tags: ["运动", "热血", "青春"],
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20of%20a%20short%20energetic%20high%20school%20volleyball%20player%20with%20orange%20hair%20jumping%20to%20spike%20a%20volleyball%20in%20a%20bright%20indoor%20gym%2C%20warm%20sunlight%20through%20windows%2C%20dynamic%20action%20pose%2C%20vivid%20anime%20art&width=480&height=640&seq=res-hq&orientation=portrait",
    year: 2014,
    episodes: "全季 85 话",
    status: "已完结",
    rating: 9.3,
    updateTime: "2026-08-09",
    summary: "身高不占优的日向翔阳，凭着惊人的弹跳力闯进全国大赛。燃到极致的运动番天花板。",
    description: "『不许低头，排球是永远向上看的运动！』身高不足的日向翔阳，在乌野高中遇到了『天才二传手』影山飞雄，两人从对手变成搭档，带领乌野一路杀向全国大赛。真实而热血的排球描写，让这部作品被誉为运动番的巅峰。全季与剧场版资源已完整整理。",
    highlights: ["运动番巅峰之作", "全季与剧场版齐全", "热血与成长并存"],
    sourceNote: "已整理全四季 85 话及排球少年剧场版垃圾场决战。",
  },
  {
    id: "oshi-no-ko",
    title: "我推的孩子",
    category: "悬疑推理",
    tags: ["偶像", "反转", "致郁"],
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20of%20a%20beautiful%20female%20idol%20with%20white%20hair%20and%20sparkling%20star%20shaped%20pupils%20on%20a%20stage%20with%20spotlights%2C%20dramatic%20pop%20stage%20lighting%2C%20glamorous%20and%20slightly%20melancholic%20tone%2C%20vivid%20anime%20art&width=480&height=640&seq=res-onk&orientation=portrait",
    year: 2023,
    episodes: "全季 24 话",
    status: "连载中",
    rating: 8.9,
    updateTime: "2026-08-08",
    summary: "转生为偶像粉丝之子的医生，在娱乐圈暗流中追寻母亲死亡的真相。开局即高能的年度话题作。",
    description: "妇产科医生阿库亚转生成了自己最推偶像爱的小孩，然而母亲爱却在一场意外中离世。他发誓要查明真相、找出凶手，在娱乐圈的光鲜与黑暗之间步步为营。独特的第一话叙事和密集的剧情反转，让这部作品成为年度话题焦点。",
    highlights: ["开局即高能的神展开", "密集反转引人入胜", "娱乐工业内幕题材"],
    sourceNote: "已整理第一季与第二季共 24 话，第三季更新实时同步。",
  },
  {
    id: "bocchi",
    title: "孤独摇滚",
    category: "日常治愈",
    tags: ["音乐", "搞笑", "青春"],
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20of%20a%20shy%20teenage%20girl%20with%20pink%20hair%20playing%20an%20electric%20guitar%20on%20a%20small%20indoor%20concert%20stage%2C%20colorful%20warm%20stage%20lights%2C%20playful%20and%20energetic%20tone%2C%20vivid%20anime%20art&width=480&height=640&seq=res-boc&orientation=portrait",
    year: 2022,
    episodes: "全季 12 话",
    status: "已完结",
    rating: 9.2,
    updateTime: "2026-08-07",
    summary: "极度社恐的吉他少女，加入一支女子乐队后笨拙又爆笑地追逐音乐梦想。年度最治愈爆款。",
    description: "『孤独摇滚』用夸张又细腻的方式，刻画了社恐少女后藤一里加入乐队『结束乐队』后的成长。害羞、脑内小剧场、爆笑的日常与真诚的音乐梦想交织，让无数观众狠狠共鸣。全季资源与音乐特辑已整理完毕。",
    highlights: ["年度最治愈爆款", "社恐共鸣感满分", "音乐现场名场面不断"],
    sourceNote: "已整理全季 12 话及剧场版总集篇，乐队音乐资源一并收录。",
  },
  {
    id: "fullmetal",
    title: "钢之炼金术师 FULLMETAL ALCHEMIST",
    category: "奇幻魔法",
    tags: ["冒险", "经典", "神作"],
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20of%20a%20young%20alchemist%20with%20golden%20hair%20in%20a%20red%20coat%20clapping%20his%20hands%20to%20create%20a%20circle%20of%20glowing%20golden%20alchemy%20light%2C%20dramatic%20warm%20amber%20lighting%2C%20epic%20fantasy%20tone%2C%20high%20detail%20anime%20art&width=480&height=640&seq=res-fma&orientation=portrait",
    year: 2009,
    episodes: "全季 64 话",
    status: "已完结",
    rating: 9.5,
    updateTime: "2026-08-06",
    summary: "为让母亲复活而触犯禁忌炼成的兄弟，踏上寻找贤者之石与真相的旅程。公认的零差评神作。",
    description: "爱德华与阿尔冯斯兄弟为复活母亲触犯『人体炼成』的禁忌，付出惨痛代价。为了找回失去的一切，他们踏上寻找贤者之石的旅途，也逐渐揭开国家背后的巨大阴谋。紧凑的剧情、深刻的主题与完整的收尾，让它成为无数观众心中的『零差评』神作。",
    highlights: ["公认的零差评神作", "剧情环环相扣", "64 话完整收尾"],
    sourceNote: "已整理 FA 全 64 话，附 2003 版动画与剧场版资源对比。",
  },
  {
    id: "steins-gate",
    title: "命运石之门",
    category: "科幻机战",
    tags: ["时间", "科幻", "悬疑"],
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20of%20a%20young%20scientist%20in%20a%20white%20lab%20coat%20standing%20before%20a%20glowing%20green%20microwave%20time%20machine%20with%20electronic%20circuits%20and%20time%20particles%2C%20dark%20room%20with%20green%20neon%20glow%2C%20sci%20fi%20mysterious%20tone%2C%20high%20detail%20anime%20art&width=480&height=640&seq=res-sg&orientation=portrait",
    year: 2011,
    episodes: "全季 24 话",
    status: "已完结",
    rating: 9.3,
    updateTime: "2026-08-05",
    summary: "一台可以发送短信到过去的微波炉，将主角卷入改变世界线的时间轮回。烧脑科幻名作。",
    description: "自称『疯狂科学家』的冈部伦太郎，无意间发现实验室的微波炉可以将短信发送到过去。每一次改动都牵动着世界线的崩塌与重构，而他必须承担起拯救挚友的重任。严谨的时间设定与层层递进的悬念，让这部作品成为科幻番的标杆。",
    highlights: ["严谨烧脑的时间设定", "层层递进的悬念", "神级结尾震撼人心"],
    sourceNote: "已整理 TV 全 24 话，含剧场版负荷领域的既视感。",
  },
];

export const featuredIds = [
  "attack-on-titan",
  "frieren",
  "one-piece",
  "haikyuu",
  "spy-family",
  "fullmetal",
];

export function getResource(id: string): AnimeResource | undefined {
  return animeResources.find((r) => r.id === id);
}